import { getCorrectEnums } from '../Functions';

// Labels of the platform items (placements), same as the ones the brand and influencer apps show.
const PLACEMENT_LABELS: Record<string, string> = {
    instagram: 'IG Post',
    instagram_post: 'IG Post',
    instagram_story: 'IG Story',
    instagram_reels: 'IG Reel',
    instagram_tv: 'IG TV',
    facebook: 'Facebook Post',
    facebook_live: 'Facebook Live',
    facebook_story: 'Facebook Story',
    tiktok: 'TT Post',
    tiktok_story: 'TT Story',
    tiktok_mirror: 'TT Mirroring',
    podcast: 'Podcast',
    youtube: 'YT Video',
    youtube_shorts: 'YT Short',
    youtube_placement: 'YT Placement',
    youtube_integration: 'YT Integration',
    youtube_live: 'YT Live',
    twitter: 'X Post',
    twitter_post: 'X Post',
    blog: 'Blog Post',
    twitch: 'Twitch',
    linkedin: 'LI Post',
    dm: 'DM',
    dm_live: 'DM Live',
};

export const getPlacementLabel = (name: string) => PLACEMENT_LABELS[name] ?? getCorrectEnums(name);
